import React from 'react'
import SearchPanelFilter from './SearchPanelFilter';
import SearchPanelFilterFukui from './SearchPanelFilterFukui';
import SearchPanelFilterKajima from './SearchPanelFilterKajima';
import SearchPanelFilterNanto from './SearchPanelFilterNanto';
import SearchPanelFilterReport from './SearchPanelFilterReport';
import SearchPanelFilterTrafficRegulation from './SearchPanelFilterTrafficRegulation';
import SearchPanelFilterJICE from './SearchPanelFilterJICE';


export default function SearchPanelFilterSwitch(props) {
    return (
        (() => {
            switch(props.viewtype) {
                //福井
                case('fukui'): {
                    return (
                        <SearchPanelFilterFukui
                        userAuthorities={props.userAuthorities}
                        keyword={props.keyword}
                        targetTypes={props.filters.type}
                        filters={props.filters}
                        onApplyFilter={props.onApplyFilter}
                        onApplyFilter_date={props.onApplyFilter_date}
                        onApplyFilter_noSearch = {props.onApplyFilter_noSearch}
                        isMobileMode={props.isMobileMode}
                        width={props.width}
                        height={props.height}
                        onSearchFilterClick={props.onSearchFilterClick}
                        updateShowFiltersInfo={props.updateShowFiltersInfo}
                        viewtype={props.viewtype}
                        searchPanelVisible={props.searchPanelVisible}
                        onSearchOptionClick={props.onSearchOptionClick}
                        />
                    )
                }
                //鹿島
                case('kajima'): {
                    return (
                        <SearchPanelFilterKajima
                        userAuthorities={props.userAuthorities}
                        keyword={props.keyword}
                        targetTypes={props.filters.type}
                        filters={props.filters}
                        onApplyFilter={props.onApplyFilter}
                        onApplyFilter_date={props.onApplyFilter_date}
                        onApplyFilter_noSearch = {props.onApplyFilter_noSearch}
                        isMobileMode={props.isMobileMode}
                        width={props.width}
                        height={props.height}
                        onSearchFilterClick={props.onSearchFilterClick}
                        updateShowFiltersInfo={props.updateShowFiltersInfo}
                        viewtype={props.viewtype}
                        searchPanelVisible={props.searchPanelVisible}
                        onSearchOptionClick={props.onSearchOptionClick}
                        />
                    )
                }
                //南砺
                case('nanto'): {
                    return (
                        <SearchPanelFilterNanto
                        userAuthorities={props.userAuthorities}
                        keyword={props.keyword}
                        targetTypes={props.filters.type}
                        filters={props.filters}
                        isMobileMode={props.isMobileMode}
                        width={props.width}
                        height={props.height}
                        updateShowFiltersInfo={props.updateShowFiltersInfo}
                        viewtype={props.viewtype}
                        searchPanelVisible={props.searchPanelVisible}

                        onApplyFilter={props.onApplyFilter}
                        onApplyFilter_date={props.onApplyFilter_date}
                        onApplyFilter_noSearch = {props.onApplyFilter_noSearch}
                        onSearchFilterClick={props.onSearchFilterClick}
                        onSearchOptionClick={props.onSearchOptionClick}
                        onSearch={props.onSearch}
                        />
                    )
                }
                //住民通報専用
                case('report'): {
                    return (
                        <SearchPanelFilterReport
                        userAuthorities={props.userAuthorities}
                        keyword={props.keyword}
                        targetTypes={props.filters.type}
                        filters={props.filters}
                        isMobileMode={props.isMobileMode}
                        width={props.width}
                        height={props.height}
                        updateShowFiltersInfo={props.updateShowFiltersInfo}
                        viewtype={props.viewtype}
                        searchPanelVisible={props.searchPanelVisible}

                        onApplyFilter={props.onApplyFilter}
                        onApplyFilter_date={props.onApplyFilter_date}
                        onApplyFilter_noSearch = {props.onApplyFilter_noSearch}
                        onSearchFilterClick={props.onSearchFilterClick}
                        onSearchOptionClick={props.onSearchOptionClick}
                        />
                    )
                }
                //通行制限専用
                case('trafficregulation'): {
                    return (
                        <SearchPanelFilterTrafficRegulation
                        userAuthorities={props.userAuthorities}
                        keyword={props.keyword}
                        targetTypes={props.filters.type}
                        filters={props.filters}
                        isMobileMode={props.isMobileMode}
                        width={props.width}
                        height={props.height}
                        updateShowFiltersInfo={props.updateShowFiltersInfo}
                        viewtype={props.viewtype}
                        searchPanelVisible={props.searchPanelVisible}
                        
                        onApplyFilter={props.onApplyFilter}
                        onApplyFilter_date={props.onApplyFilter_date}
                        onApplyFilter_noSearch = {props.onApplyFilter_noSearch}
                        onSearchFilterClick={props.onSearchFilterClick}
                        onSearchOptionClick={props.onSearchOptionClick}
                        />
                    )
                }
                //JICE
                case('jice'): {
                    return (
                        <SearchPanelFilterJICE
                        userAuthorities={props.userAuthorities}
                        keyword={props.keyword}
                        targetTypes={props.filters.type}
                        filters={props.filters}
                        onApplyFilter={props.onApplyFilter}
                        onApplyFilter_date={props.onApplyFilter_date}
                        onApplyFilter_noSearch = {props.onApplyFilter_noSearch}
                        isMobileMode={props.isMobileMode}
                        width={props.width}
                        height={props.height}
                        onSearchFilterClick={props.onSearchFilterClick}
                        updateShowFiltersInfo={props.updateShowFiltersInfo}
                        viewtype={props.viewtype}
                        searchPanelVisible={props.searchPanelVisible}
                        onSearchOptionClick={props.onSearchOptionClick}
                        />
                    )
                }
                //その他
                default: {
                    return (
                        <SearchPanelFilter
                        userAuthorities={props.userAuthorities}
                        keyword={props.keyword}
                        targetTypes={props.filters.type}
                        filters={props.filters}
                        onApplyFilter={props.onApplyFilter}
                        onApplyFilter_date={props.onApplyFilter_date}
                        onApplyFilter_noSearch = {props.onApplyFilter_noSearch}
                        isMobileMode={props.isMobileMode}
                        width={props.width}
                        height={props.height}
                        onSearchFilterClick={props.onSearchFilterClick}
                        updateShowFiltersInfo={props.updateShowFiltersInfo}
                        viewtype={props.viewtype}
                        searchPanelVisible={props.searchPanelVisible}
                        onSearchOptionClick={props.onSearchOptionClick}
                        />
                    )
                }
            }
        })()
    );

}
